import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EditionPage } from '@features/models/events/editions/edition-page';

@Injectable()
export class EditionPageService {

  private _editionUrl = '/edition/:id'; 

  private _http = inject(HttpClient);

  constructor() { }

  getEditionData(editionId: string): Observable<EditionPage> {
    return this._http.get<EditionPage>(
      this._editionUrl.replace(":id", editionId)
    );
  }

}
